import {CalendarScreenTypeEnum} from "@/enums/CalendarScreenTypeEnum";
import {EventsTypes} from "@/enums/EventsTypes";

export class CalendarFilters {
  screenType: string;
  type: string;
  wingName: string;
  wingId: string;
  wingsIds: string[];
  filters: Array<string>;
  locationEnabled: boolean;
  locationSearchValue: string;
  residentEnabled: boolean;
  residentSearchValue: string;
  lifestyleProgramsEnabled: boolean;
  lifestyleProgramsSearchValue: string;

  constructor() {
    this.screenType = CalendarScreenTypeEnum.Calendar;
    this.type = 'week';
    this.wingName = '';
    this.wingId = '';
    this.wingsIds = [];
    this.filters = [
      EventsTypes.ConciergeRequest,
      EventsTypes.LifestylePrograms,
      EventsTypes.PremiumServices,
      EventsTypes.Meal
    ];
    this.locationEnabled = false;
    this.locationSearchValue = '';
    this.residentEnabled = false;
    this.residentSearchValue = '';
    this.lifestyleProgramsEnabled = true;
    this.lifestyleProgramsSearchValue = '';
  }
}